import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid, TextField } from '@material-ui/core';
import { resolveSagisClaim } from 'helpers/utils';
import { arrayTranslate, translate } from 'containers/services/translate';
import messages from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/messages';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { cloneDeep, get, isEmpty, isNil } from 'lodash';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import ImportImagineDocumentButton from 'containers/CourtManagerLegalProceedings/ImagineDocuments/ImportButton';
import UploadDocumentBloc from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/UploadDocumentBloc';
import { getDocumentId } from 'containers/common/LegalProceedings/ExpertReport/utils';
import { DOCUMENT_TYPES } from 'constants/global';
import { Listings } from 'containers/AppContainer/typings';
import ExpertReportDecision from 'containers/CourtManagerLegalProceedings/ExpertReport/Decision';
import {
  getExpertise,
  showUpdateButton,
} from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/utils';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { accountingExpertiseValidator } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/form-validations';
import { displayErrorText } from 'containers/services/validateForm';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import { EMPTY_DOCUMENT } from 'containers/data-structure';
export interface AccountingExpertiseProps {
  intl: IntlShape;
  listings: Listings;
  expertReport: any;
  setExpertReport: Function;
  expertiseJudgementAddDocumentId: string;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  setDocumentId: Function;
  documentIndex: number;
  isManager?: boolean;
  isDecisionDialgOpen?: boolean;
  setIsDecisionDialgOpen?: Function;
  documentId: string;
  isRejected?: boolean;
  isAppeal?: boolean;
  isRecap?: boolean;
  isAssignedLawyer: boolean;
  isExpertReportValidated: boolean;
  username: string;
  isLawyerAssignedJudiciary?: boolean;
  expertReportState: ExpertReportType;
  imagineDocuments: any;
  claimId: number;
  policyInfo: any;
  requestGetDocByDocumentumId: Function;
}

export const AccountingExpertise: React.FC<AccountingExpertiseProps> = ({
  expertReport,
  ...props
}): JSX.Element => {
  const { EXPERT_FIELDS, EXPERT_TYPE, DOCUMENT } = getExpertise(
    expertReport,
  ) as any;
  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const validateAccounting = accountingExpertiseValidator(
    expertReport[EXPERT_TYPE],
    EXPERT_TYPE,
  );

  const { message } =
    displayErrorText(
      validateAccounting,
      translateArrayErrorMessages(validateAccounting, true),
    ) || {};

  const ExpertField = ACCOUNTING_TYPE[EXPERT_TYPE];

  const setDocument = (document: CorporealDocument) => {
    const id = getDocumentId(
      String(expertReport.id),
      expertReport.expertiseJudgementAddDocumentId as string,
    );
    const vehExpertise = cloneDeep(expertReport);
    if (id === props.documentId) {
      vehExpertise[EXPERT_TYPE][EXPERT_FIELDS[DOCUMENT]].push(document);
      props.setExpertReport(vehExpertise);
      props.resetUploadedDocument();
    }
  };

  const [expertReportDocument, setExpertReportDocument] = useState({
    ...EMPTY_DOCUMENT,
  });

  const [oldExpertReportDocument, setOldExpertReportDocument] = useState({
    ...EMPTY_DOCUMENT,
  });

  const setExpertReportDoc = (document: CorporealDocument) => {
    const vehExpertise = cloneDeep(expertReport);
    if (
      getDocumentId(
        String(expertReport.id) as string,
        props.expertiseJudgementAddDocumentId as string,
      ) === props.documentId
    ) {
      vehExpertise[EXPERT_TYPE][EXPERT_FIELDS[DOCUMENT]] = [
        { ...document, id: get(oldExpertReportDocument, 'id', null) },
      ];

      setExpertReportDocument(document as any);
      props.setExpertReport(vehExpertise);
      props.resetUploadedDocument();
    }
  };

  useEffect(() => {
    setOldExpertReportDocument(
      get(expertReport[EXPERT_TYPE], [EXPERT_FIELDS[DOCUMENT], '0'], {}),
    );
  }, [expertReport]);
  return (
    <div className="global-expertise-container">
      <div className="accounting-wrapper">
        <div className="accounting-form">
          <ExpertField
            {...props}
            expertReport={expertReport}
            message={message}
          />
          <Grid container direction="column">
            <Grid item xs={5}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs>
                  <UploadDocumentBloc
                    document={oldExpertReportDocument}
                    setDocument={setDocument}
                    uploadDocument={props.uploadDocument}
                    uploadedDocument={props.uploadedDocument}
                    resetUploadedDocument={props.resetUploadedDocument}
                    docType={DOCUMENT_TYPES.EXPERT_REPORT}
                    index={props.documentIndex}
                    docId={getDocumentId(
                      String(expertReport.id) as string,
                      props.expertiseJudgementAddDocumentId as string,
                    )}
                    setDocumentId={props.setDocumentId}
                    shouldDisplay={false}
                  />
                </Grid>
                <Grid item style={{ marginTop: '20px' }}>
                  {!isEmpty(props.imagineDocuments) &&
                    props.isManager &&
                    isNil(get(expertReport, 'victimExpertise.id', null)) &&
                    featureService.hasFeature(
                      FEATURES.TRAITEMENT_IMAGINE_DOC,
                    ) && (
                      <ImportImagineDocumentButton
                        listings={props.listings}
                        managerNotifcationsInboxes={props.imagineDocuments}
                        claimId={props.claimId}
                        imagineDocuments={props.imagineDocuments}
                        claimSagisInfo={resolveSagisClaim(props.policyInfo)}
                        uploadDocument={props.uploadDocument}
                        uploadedDocument={props.uploadedDocument}
                        setUploadedDocs={setDocument}
                        documentName={DOCUMENT_TYPES.EXPERT_REPORT}
                        documentType={DOCUMENT_TYPES.EXPERT_REPORT}
                        documentId={getDocumentId(
                          String(expertReport.id) as string,
                          props.expertiseJudgementAddDocumentId as string,
                        )}
                        setDocumentId={props.setDocumentId}
                        requestGetDocByDocumentumId={
                          props.requestGetDocByDocumentumId
                        }
                      />
                    )}
                </Grid>
              </Grid>
            </Grid>

            {((props.isRejected &&
              (!isEmpty(get(expertReport[EXPERT_TYPE], 'creator', ''))
                ? get(expertReport[EXPERT_TYPE], 'creator', '') ===
                  props.username
                : props.isAssignedLawyer)) ||
              showUpdateButton(
                props.expertReportState,
                EXPERT_TYPE,
                expertReport[EXPERT_TYPE],
                props.isManager,
              )) && (
              <Grid item xs={5}>
                <div className="add-recap-bloc-title">
                  {translate(messages.newDocument, props)}
                </div>
                <UploadDocumentBloc
                  document={expertReportDocument}
                  setDocument={setExpertReportDoc}
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadedDocument}
                  docType={
                    !props.isAppeal
                      ? DOCUMENT_TYPES.EXPERT_REPORT
                      : DOCUMENT_TYPES.EXPERT_REPORT_APPEAL
                  }
                  index={props.documentIndex}
                  docId={getDocumentId(
                    String(expertReport.id) as string,
                    props.expertiseJudgementAddDocumentId as string,
                  )}
                  setDocumentId={props.setDocumentId}
                  shouldDisplay={false}
                />
              </Grid>
            )}
          </Grid>
        </div>
        <Grid container direction="row">
          {get(expertReport, `${[EXPERT_TYPE]}.isOld`) && (
            <Grid item xs={6} className="caduc-position">
              <article className="caduc-item">
                {translate(messages.deprecated, props)}
              </article>
            </Grid>
          )}

          {(featureService.hasFeature(FEATURES.EVOLUTION_P1)
            ? true
            : !get(expertReport, `${[EXPERT_TYPE]}.isOld`)) &&
            (props.isLawyerAssignedJudiciary ||
              props.isManager ||
              userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCOURTMONITORINGMANAGER,
              )) && (
              <Grid item>
                <section className="expert-report-decision-wrapper">
                  {get(expertReport, `${[EXPERT_TYPE]}.creator`, '') && (
                    <span
                      style={{
                        fontWeight: 'bold',
                        fontSize: '12px',
                        color: '#0072c6',
                      }}
                    >
                      {translate(messages.creatorTitle, props, {
                        lawyer: get(
                          expertReport,
                          `${[EXPERT_TYPE]}.creator`,
                          '',
                        ),
                      })}
                    </span>
                  )}
                </section>
                <ExpertReportDecision
                  expertise={expertReport}
                  setExpertise={props.setExpertReport}
                  isDecisionDialgOpen={props.isDecisionDialgOpen as boolean}
                  isManager={props.isManager as boolean}
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadedDocument}
                  setIsDecisionDialgOpen={
                    props.setIsDecisionDialgOpen as Function
                  }
                  isExpertReportValidated={props.isExpertReportValidated}
                  expertReportState={props.expertReportState}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
              </Grid>
            )}
        </Grid>
      </div>
    </div>
  );
};

const ACCOUNTING_TYPE = {
  victimExpertise: ({ ...props }) => {
    const { EXPERT_FIELDS, EXPERT_TYPE } = getExpertise(
      props.expertReport,
    ) as any;

    const handleChange = (e: React.ChangeEvent<{ value: string }>) => {
      const expertiseReport = { ...props.expertReport };
      expertiseReport[EXPERT_TYPE][EXPERT_FIELDS.FIXED_ANNUAL_INCOME] =
        e.target.value === '' ? null : e.target.value;
      expertiseReport[EXPERT_TYPE]['injuryPostKey'] =
        props.expertReport['injuryPostKey'];
      expertiseReport[EXPERT_TYPE]['previousItt'] = props.expertReport['itt'];
      props.setExpertReport(expertiseReport);
    };

    return (
      <TextField
        label={translate(messages.annualFixedRevenue, props)}
        name={EXPERT_FIELDS.FIXED_ANNUAL_INCOME}
        value={get(
          props.expertReport[EXPERT_TYPE],
          EXPERT_FIELDS.FIXED_ANNUAL_INCOME,
          null,
        )}
        type="number"
        onChange={handleChange}
        InputProps={{
          disabled:
            props.isManager || props.isRejected
              ? false
              : !isNil(get(props.expertReport[EXPERT_TYPE], EXPERT_FIELDS.ID)),
        }}
        error={props.message[EXPERT_FIELDS.FIXED_ANNUAL_INCOME]}
        helperText={props.message[EXPERT_FIELDS.FIXED_ANNUAL_INCOME]}
        className="item-field"
      />
    );
  },
  vehiculeExpertise: ({ ...props }) => {
    const { EXPERT_FIELDS, EXPERT_TYPE } = getExpertise(
      props.expertReport,
    ) as any;
    const handleChange = (e: React.ChangeEvent<{ value: string }>) => {
      const expertiseReport = { ...props.expertReport };

      expertiseReport[EXPERT_TYPE][EXPERT_FIELDS.DAMAGE_AMOUNT] =
        e.target.value;
      props.setExpertReport(expertiseReport);
    };
    return (
      <TextField
        label={translate(messages.damageAmount, props)}
        name={EXPERT_FIELDS.DAMAGE_AMOUNT}
        value={get(
          props.expertReport[EXPERT_TYPE],
          EXPERT_FIELDS.DAMAGE_AMOUNT,
          '',
        )}
        type="number"
        onChange={handleChange}
        InputProps={{ disabled: props.readOnly }}
        className="mechanical-item-field"
        error={!!get(props.message, [EXPERT_FIELDS.DAMAGE_AMOUNT])}
        helperText={props.message[EXPERT_FIELDS.DAMAGE_AMOUNT]}
      />
    );
  },
} as any;
export default injectIntl(AccountingExpertise);
